import { cn } from '../lib/utils.js';

/** @param {import('react').ComponentProps<'div'>} props */
export function Card({ className, ...props }) {
  return <div data-slot="card" className={cn('flex flex-col gap-4 rounded-lg border bg-card py-4 text-card-foreground', className)} {...props} />;
}

/** @param {import('react').ComponentProps<'div'>} props */
export function CardHeader({ className, ...props }) {
  return <div data-slot="card-header" className={cn('flex flex-col gap-1 px-4', className)} {...props} />;
}

/** @param {import('react').ComponentProps<'h3'> & { as?: 'h1'|'h2'|'h3'|'h4'|'div' }} props */
export function CardTitle({ className, as: Comp = 'h3', ...props }) {
  return <Comp data-slot="card-title" className={cn('text-base font-semibold leading-tight', className)} {...props} />;
}

/** @param {import('react').ComponentProps<'p'>} props */
export function CardDescription({ className, ...props }) {
  return <p data-slot="card-description" className={cn('text-sm text-muted-foreground', className)} {...props} />;
}

/** @param {import('react').ComponentProps<'div'>} props */
export function CardContent({ className, ...props }) {
  return <div data-slot="card-content" className={cn('px-4', className)} {...props} />;
}

/** @param {import('react').ComponentProps<'div'>} props */
export function CardFooter({ className, ...props }) {
  return <div data-slot="card-footer" className={cn('flex items-center gap-2 px-4', className)} {...props} />;
}
